'use client'

import { featureFlagKeys } from 'feature-flags/constants/featureFlags'
import { useFeatureFlag } from 'feature-flags/hooks/useFeatureFlag/useFeatureFlag'
import { Domains } from 'monitoring/constants/domains'
import { useLog } from 'monitoring/sendLog/client/useLog'
import { auth as authEvent } from 'security/components/CIAM/events/auth/auth'
import { clear as clearEvent } from 'security/components/CIAM/events/clear/clear'
import { initialize as initializeEvent } from 'security/components/CIAM/events/initialize/initialize'
import { session as sessionEvent } from 'security/components/CIAM/events/session/session'
import type { ActionTypes, FeatureFlag } from 'security/types/CIAM'

export function useCIAM() {
	const {
		enabled,
		variables: { isDRSEnabled, isOTPEnabled },
	} = useFeatureFlag<FeatureFlag>(featureFlagKeys.CIAM)
	const { sendLog } = useLog()

	const session = async (type: ActionTypes) => {
		if (enabled && isDRSEnabled) {
			try {
				const sessionToken = await sessionEvent(type)

				if (sessionToken && isOTPEnabled) {
					return sessionToken
				}
			} catch {
				sendLog({
					domain: Domains.CIAM,
					message: `[${type}] Session DRS Fail.`,
				})
			}
		}
		return undefined
	}

	const auth = (userId: string | null) => {
		if (enabled) {
			try {
				authEvent(userId)
			} catch {
				sendLog({ domain: Domains.CIAM, message: 'Auth Fail' })
			}
		}
	}

	const clear = () => {
		if (enabled) {
			try {
				clearEvent()
			} catch {
				sendLog({ domain: Domains.CIAM, message: 'Clear Fail' })
			}
		}
	}

	const initialize = () => {
		if (enabled) {
			try {
				initializeEvent()
			} catch {
				sendLog({ domain: Domains.CIAM, message: 'Init Fail' })
			}
		}
	}

	return {
		session,
		auth,
		clear,
		initialize,
		isOTPEnabled,
		enabled,
	}
}
